/**
 * @file Web Gallery photo card component.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import CustomControl from '../../../components/global/CustomControl';
import ProgressivePhoto from '../../../components/grid/ProgressivePhoto';
import { IMAGE_SIZE_CODE } from '../../../constants/image-size-codes';

const propTypes = {
  id: PropTypes.string,
  selectable: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  linkTo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      state: PropTypes.shape({
        basePath: PropTypes.string.isRequired,
        step: PropTypes.number,
      }),
    }),
  ]).isRequired,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      url: PropTypes.string,
      size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
    }),
  ),
  size: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
  useCheckbox: PropTypes.bool,
  selectableContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  progressive: PropTypes.bool,
  linkProps: PropTypes.shape({
    rel: PropTypes.string,
  }),
};

const WebGalleryPhotoCard = ({
  id,
  selectable = false,
  isSelected = false,
  children,
  className,
  onSelect,
  linkTo,
  thumbnails,
  selectableContent,
  size,
  useCheckbox,
  progressive,
  linkProps,
}) => {
  const classes = classNames({
    'photo-grid-card': true,
    'pos-rel': true,
    'web-gallery-photo-grid-card': true,
    selectable,
    selected: isSelected,
    [className]: !!className,
  });

  return (
    // eslint-disable-next-line
    <div className={classes} onClick={onSelect}>
      {!selectable ? (
        <Link to={linkTo} {...(linkProps ?? {})}>
          <ProgressivePhoto
            thumbnails={thumbnails}
            size={size}
            progressive={progressive}
          />
        </Link>
      ) : (
        <ProgressivePhoto
          thumbnails={thumbnails}
          size={size}
          progressive={progressive}
        />
      )}

      {selectable ? (
        <Fragment>
          {useCheckbox && (
            <CustomControl
              id={`checkbox-${id}`}
              label={isSelected ? 'Photo selected' : 'Select this photo'}
              labelSrOnly
              type="checkbox"
              checked={isSelected}
              onClick={e => {
                e.stopPropagation();
              }}
              onChange={e => {
                e.stopPropagation();
              }}
              readOnly
              size="xl"
            />
          )}
          {selectableContent}
        </Fragment>
      ) : (
        children
      )}
    </div>
  );
};

WebGalleryPhotoCard.propTypes = propTypes;

export default WebGalleryPhotoCard;
